export default "__VITE_ASSET__DHYnsPzd__"